<script lang="ts">
    import {assets as assetPath} from '$app/paths';
    export let waveColor : 'navy' | 'white' | 'cerulean' | 'lightgrey' | 'custom' | 'dark' = "navy"
    export let rotate : boolean = false;
    export let className : string = ''
</script>

{#if waveColor === 'navy'}
    <div class:rotate="{rotate === true}">
        <img src={`${assetPath}/assets/navywave.svg`} class="wave--img {className}" alt="navy wave"/>
    </div>
{:else if waveColor === 'custom'}
    <div class:rotate="{rotate === true}">
        <img src={`${assetPath}/assets/blackdotted-wave.svg`} class="wave--img {className}" alt="black space wave"/>
    </div>
{:else if waveColor === 'cerulean'}
    <div class:rotate="{rotate === true}">
        <img src={`${assetPath}/assets/cerulean-wave.png`} class="wave--img {className}" alt="blue wave"/>
    </div>
{:else if waveColor === 'lightgrey'}
    <div class:rotate="{rotate === true}">
        <img src={`${assetPath}/assets/lightgrey-wave.svg`} class="wave--img grey-wave {className}" alt="grey wave"/>
    </div>
{:else if waveColor === 'dark'}
    <div class:rotate="{rotate === true}">
        <img src={`${assetPath}/assets/dark-wave.svg`} class="wave--img {className}" alt="dark wave"/>
    </div>
{:else}
    <div class:rotate="{rotate === true}" >
        <img src={`${assetPath}/assets/whitewave.svg`} class="wave--img {className}" alt="white wave"/>
    </div>
{/if}


<style lang="postcss">
    @import '../../styles/_mixins.css';

    .rotate {
        transform: rotate(180deg);
    }

    .wave--img {
        width:100%;
        max-height:200px;
        display:flex;
        aspect-ratio: 1/1;

        @mixin screen-md {
            max-height:150px;
        }

        @mixin screen-sm {
            display:none;
        }
    }

    .grey-wave { 
        margin:-3px 0;
    }
</style>